import {Box, Typography} from '@mui/material';
import AurButton from '../../../common/aur-button/AurButton';
import {numberFormatter} from '../../../../utils/utils';

interface ReportSidebarData {
  groupName: string;
  items: Sidebaritems[];
}
interface Sidebaritems {
  name: string;
  count: number;
}

interface ReportSideBarProps {
  sidebarData: ReportSidebarData[];
  activeItemName: string;
  setActiveItem: (name: string) => void;
}
const ReportSideBar = (props: ReportSideBarProps) => {
  const {sidebarData, activeItemName, setActiveItem} = props;

  return (
    <div className="report-side-bar">
      {sidebarData.map((item) => (
        <Box key={item.groupName} className="group">
          <Typography className="typo-text label1_size">
            {item.groupName}
          </Typography>
          {item.items.map((subItem) => (
            <AurButton
              key={subItem.name}
              dataTestId={subItem.name}
              type="continue"
              onClick={() => {
                setActiveItem(subItem.name);
              }}
              classNames={`sidebar-btn ${activeItemName == subItem.name ? ' active' : ''}`}
            >
              <Typography className="typo-text label1_size">
                {subItem.name}
              </Typography>
              <Typography className="typo-text label1_size">
                {numberFormatter(subItem.count ?? 0)}
              </Typography>
            </AurButton>
          ))}
        </Box>
      ))}
    </div>
  );
};

export default ReportSideBar;
